import {
  appsCatalogApiListMaterials,
  getAppsCatalogApiListMaterialsQueryKey,
} from '@/lib/api/generated/endpoints'
import type { MaterialOut } from '@/lib/api/generated/types.ts/materialOut'
import { queryOptions } from '@tanstack/react-query'

/**
 * Material catalog — used by inventory tabs / receipts to translate
 * `material_id` (opaque on stock items) into a human-readable label
 * (`code`, `name`).
 *
 * Backend contract (post global-catalog refactor):
 *  - `GET /api/catalog/materials` → `MaterialOut[]` (bare array, no envelope).
 *    Catalog is project-agnostic; every project shares the same global
 *    materials. The caller no longer scopes by `project_id` — that argument
 *    only exists in the wrapper for cache-key compatibility with prefetch
 *    sites that still pass it; it is ignored by the backend call.
 *
 * Cached longer than transactional reads — material catalog is rarely edited
 * relative to stock movements.
 */

export const materialCatalogQuery = (_projectId: number) =>
  queryOptions({
    queryKey: getAppsCatalogApiListMaterialsQueryKey(),
    queryFn: async ({ signal }) =>
      (await appsCatalogApiListMaterials(undefined, {
        signal,
      })) as unknown as readonly MaterialOut[],
    staleTime: 5 * 60 * 1000,
  })
